import { render } from "./DetalharBandeiraPagamento.vue?vue&type=template&id=2ae261f0&scoped=true"
import script from "./DetalharBandeiraPagamento.vue?vue&type=script&lang=js"
export * from "./DetalharBandeiraPagamento.vue?vue&type=script&lang=js"

import "./DetalharBandeiraPagamento.vue?vue&type=style&index=0&id=2ae261f0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae261f0"]])

export default __exports__